<template>
    <b-modal
            v-model="modal.state"
            @hidden="hideModal"
            modal-class="knowledge-asset-modal"
            size="xl"
            centered
            hide-footer
            body-class="pt-0 pb-0"
            no-close-on-esc
    >
        <template v-slot:modal-header="{ close }">
            <b-button
                    variant="link"
                    class="close"
                    @click="close"
            >
                <i class="far fa-times" />
            </b-button>
        </template>
        <template v-slot:default>
            <div>
                <div v-if="entity">
                    <knowledge-asset-content
                            :asset="entity"
                            article-content-over-image
                    />
                </div>
            </div>
        </template>
    </b-modal>
</template>

<script>
    import './KnowledgeAssetModal.scss';
    import {assertType} from "../../../../helpers/assert";
    import KnowledgeAssetAppResource
        from "@milestoneslabs/milestones-core-js/src/AppResources/KnowledgeAssetAppResource";
    import KnowledgeAssetContent from "../KnowledgeAssetContent/KnowledgeAssetContent";

    export const KNOWLEDGE_ASSET_MODAL_SHOW = 'KNOWLEDGE_ASSET_MODAL_SHOW';
    export default {
        name: "KnowledgeAssetModal",
        components: {
            KnowledgeAssetContent
        },
        data() {
            return {
                modal: {
                    state: false
                },
                entity: null
            };
        },
        methods: {
            hideModal() {
                this.modal.state = false;
            },
            showAssetModal({entity}) {
                assertType(
                    entity,
                    KnowledgeAssetAppResource,
                );
                this.entity = entity;
                this.modal.state = true;
            },
        },
        beforeMount() {
            this.$bus.$on(KNOWLEDGE_ASSET_MODAL_SHOW, this.showAssetModal);
        },

        beforeDestroy() {
            this.$bus.$off(KNOWLEDGE_ASSET_MODAL_SHOW, this.showAssetModal);
        }
    };
</script>
